// import React, { useState, useRef, useEffect } from "react";
// import { BarChart } from "@mui/x-charts/BarChart";
// import Modal from "@mui/material/Modal";
// import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
// import "./chart.css";

// // Define series colors
// const SERIES_COLORS = {
//   Present: "#D4EDBC",
//   Absent: "#FF0000",
//   "Half-Day": "#C27BA0",
//   "On-Leave": "#6FA8DC",
//   "Late-Arrival": "#E69138",
//   "Week Off": "#F1C232",
// };

// const Chart = ({
//   getGraphListData,
//   handleDate,
//   handleClearSelection,
//   datedash,
// }) => {
//   const [open, setOpen] = useState(false);
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [selectedStore, setSelectedStore] = useState(null);
//   const chartRef = useRef(null);

//   // Store names remain unchanged
//   const storeNames = getGraphListData?.map((store) => store.store_name) || [];

//   // Calculate total employees per store
//   const storeTotals =
//     getGraphListData?.map((store) => {
//       return (
//         store.Present.length +
//         store.Absent.length +
//         store["Half-Day"].length +
//         store["On-Leave"].length +
//         store["Late-Arrival"].length +
//         store["Week Off"].length
//       );
//     }) || [];

//   // Calculate proportion data for each category
//   const presentProportionData =
//     getGraphListData?.map((store, index) => {
//       return storeTotals[index] > 0
//         ? store.Present.length / storeTotals[index]
//         : 0;
//     }) || [];
//   const absentProportionData =
//     getGraphListData?.map((store, index) => {
//       return storeTotals[index] > 0
//         ? store.Absent.length / storeTotals[index]
//         : 0;
//     }) || [];
//   const halfDayProportionData =
//     getGraphListData?.map((store, index) => {
//       return storeTotals[index] > 0
//         ? store["Half-Day"].length / storeTotals[index]
//         : 0;
//     }) || [];
//   const onLeaveProportionData =
//     getGraphListData?.map((store, index) => {
//       return storeTotals[index] > 0
//         ? store["On-Leave"].length / storeTotals[index]
//         : 0;
//     }) || [];
//   const lateArrivalProportionData =
//     getGraphListData?.map((store, index) => {
//       return storeTotals[index] > 0
//         ? store["Late-Arrival"].length / storeTotals[index]
//         : 0;
//     }) || [];
//   const weekOffProportionData =
//     getGraphListData?.map((store, index) => {
//       return storeTotals[index] > 0
//         ? store["Week Off"].length / storeTotals[index]
//         : 0;
//     }) || [];

//   // Handle bar clicks (unchanged)
//   const handleBarClick = (event, elements) => {
//     console.log("Bar Click:", elements);
//     if (elements?.seriesId && elements?.dataIndex !== undefined) {
//       const { seriesId, dataIndex } = elements;
//       const store = getGraphListData[dataIndex];
//       let categoryData;
//       let categoryName;
//       let status;

//       switch (seriesId) {
//         case "presentId":
//           categoryData = store.Present;
//           categoryName = "Present";
//           status = "Present";
//           break;
//         case "absentId":
//           categoryData = store.Absent;
//           categoryName = "Absent";
//           status = "Absent";
//           break;
//         case "halfDayId":
//           categoryData = store["Half-Day"];
//           categoryName = "Half-Day";
//           status = "Half-Day";
//           break;
//         case "leaveId":
//           categoryData = store["On-Leave"];
//           categoryName = "On-Leave";
//           status = "On-Leave";
//           break;
//         case "lateId":
//           categoryData = store["Late-Arrival"];
//           categoryName = "Late-Arrival";
//           status = "Late";
//           break;
//         case "weekOffId":
//           categoryData = store["Week Off"];
//           categoryName = "Week Off";
//           status = "Weekly Off";
//           break;
//         default:
//           return;
//       }

//       const updatedCategoryData = categoryData.map((item) => ({
//         ...item,
//         status,
//       }));

//       setSelectedCategory({ name: categoryName, data: updatedCategoryData });
//       setSelectedStore(store.store_name);
//       setOpen(true);
//     }
//   };

//   // Attach click listeners to x-axis labels (unchanged)
//   useEffect(() => {
//     const chartElement = chartRef.current;
//     if (!chartElement) {
//       console.log("Chart ref not available yet");
//       return;
//     }

//     console.log("Chart ref available:", chartElement);

//     let labels = chartElement.querySelectorAll(".MuiChartsAxis-tickLabel");
//     console.log("Initial labels check:", labels.length);

//     const attachListeners = () => {
//       labels = chartElement.querySelectorAll(".MuiChartsAxis-tickLabel");
//       console.log("Attaching listeners. Found labels:", labels.length);

//       if (labels.length === 0) {
//         console.log(
//           "No labels found yet. SVG content:",
//           chartElement.innerHTML
//         );
//         return;
//       }

//       labels.forEach((label, index) => {
//         label.style.pointerEvents = "auto";
//         label.style.cursor = "pointer";

//         const handleLabelClick = (event) => {
//           event.stopPropagation();
//           event.preventDefault();
//           const storeName = label.textContent;
//           const storeIndex = storeNames.indexOf(storeName);
//           if (storeIndex !== -1) {
//             const store = getGraphListData[storeIndex];
//             const allStoreData = [
//               ...store.Present.map((item) => ({ ...item, status: "Present" })),
//               ...store.Absent.map((item) => ({ ...item, status: "Absent" })),
//               ...store["Half-Day"].map((item) => ({
//                 ...item,
//                 status: "Half-Day",
//               })),
//               ...store["On-Leave"].map((item) => ({
//                 ...item,
//                 status: "On-Leave",
//               })),
//               ...store["Late-Arrival"].map((item) => ({
//                 ...item,
//                 status: "Late",
//               })),
//               ...store["Week Off"].map((item) => ({
//                 ...item,
//                 status: "Weekly Off",
//               })),
//             ];

//             console.log(`Label ${index} Clicked:`, storeName);
//             setSelectedCategory({ name: "All Categories", data: allStoreData });
//             setSelectedStore(store.store_name);
//             setOpen(true);
//           } else {
//             console.log("Store not found for label:", storeName);
//           }
//         };

//         label.addEventListener("click", handleLabelClick);
//       });
//     };

//     if (labels.length > 0) {
//       attachListeners();
//     } else {
//       const observer = new MutationObserver((mutations) => {
//         console.log("Mutation observed:", mutations);
//         labels = chartElement.querySelectorAll(".MuiChartsAxis-tickLabel");
//         if (labels.length > 0) {
//           console.log("Labels detected after mutation:", labels.length);
//           attachListeners();
//           observer.disconnect();
//         }
//       });

//       observer.observe(chartElement, { childList: true, subtree: true });
//       console.log("MutationObserver started");

//       const timeout = setTimeout(() => {
//         labels = chartElement.querySelectorAll(".MuiChartsAxis-tickLabel");
//         if (labels.length > 0) {
//           console.log("Fallback: Labels found after timeout:", labels.length);
//           attachListeners();
//         } else {
//           console.log(
//             "Fallback: Still no labels after 2s:",
//             chartElement.innerHTML
//           );
//         }
//         observer.disconnect();
//       }, 2000);

//       return () => {
//         observer.disconnect();
//         clearTimeout(timeout);
//         labels.forEach((label) => {
//           label.removeEventListener("click", () => {});
//         });
//       };
//     }

//     return () => {
//       labels.forEach((label) => {
//         label.removeEventListener("click", () => {});
//       });
//     };
//   }, [getGraphListData, chartRef.current]);

//   const handleClose = () => {
//     setOpen(false);
//     setSelectedCategory(null);
//     setSelectedStore(null);
//   };
//   const presentCounts =
//     getGraphListData?.map((store) => store.Present.length) || [];
//   const absentCounts =
//     getGraphListData?.map((store) => store.Absent.length) || [];
//   const halfDayCounts =
//     getGraphListData?.map((store) => store["Half-Day"].length) || [];
//   const onLeaveCounts =
//     getGraphListData?.map((store) => store["On-Leave"].length) || [];
//   const lateArrivalCounts =
//     getGraphListData?.map((store) => store["Late-Arrival"].length) || [];
//   const weekOffCounts =
//     getGraphListData?.map((store) => store["Week Off"].length) || [];
//   const modalStyle = {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: 1100,
//     bgcolor: "background.paper",
//     border: "1px solid #000",
//     boxShadow: 24,
//     p: 4,
//   };

//   console.log({ presentCounts });

//   return (
//     <div
//       style={{
//         padding: "10px 0px",
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         marginTop: "20px",
//       }}
//     >
//       <div className="d-flex justify-content-between w-100">
//         <h2
//           className="text-center"
//           style={{ width: "-webkit-fill-available", marginLeft: "120px" }}
//         >
//           Attendance Summary
//         </h2>
//         <div className="calendar_pad w-[25]">
//           <div className="calendar">
//             <input type="date" value={datedash} onChange={handleDate} />
//             {datedash && (
//               <div className="calenderClear">
//                 <svg
//                   width="20"
//                   height="25"
//                   viewBox="0 0 60 60"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                   onClick={handleClearSelection}
//                 >
//                   <rect
//                     width="60"
//                     height="60"
//                     rx="30"
//                     fill="#2C357D"
//                     fill-opacity="0.15"
//                   />
//                   <path
//                     d="M37.75 22.1377L21.25 38.6377"
//                     stroke="#2C357D"
//                     stroke-width="3"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                   <path
//                     d="M21.25 22.1377L37.75 38.6377"
//                     stroke="#2C357D"
//                     stroke-width="3"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                 </svg>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <BarChart
//         ref={chartRef}
//         height={500}
//         margin={{ bottom: 100 }}
//         series={[
//           {
//             data: presentProportionData,
//             label: "Present",
//             id: "presentId",
//             stack: "total",
//             color: SERIES_COLORS["Present"],
//             valueFormatter: (value, { dataIndex }) =>
//               `${presentCounts[dataIndex]}`, // Show raw count on hover
//           },
//           {
//             data: absentProportionData,
//             label: "Absent",
//             id: "absentId",
//             stack: "total",
//             color: SERIES_COLORS["Absent"],
//             valueFormatter: (value, { dataIndex }) =>
//               `${absentCounts[dataIndex]}`, // Show raw count on hover
//           },
//           {
//             data: halfDayProportionData,
//             label: "Half-Day",
//             id: "halfDayId",
//             stack: "total",
//             color: SERIES_COLORS["Half-Day"],
//             valueFormatter: (value, { dataIndex }) =>
//               `${halfDayCounts[dataIndex]}`, // Show raw count on hover
//           },
//           {
//             data: onLeaveProportionData,
//             label: "On-Leave",
//             id: "leaveId",
//             stack: "total",
//             color: SERIES_COLORS["On-Leave"],
//             valueFormatter: (value, { dataIndex }) =>
//               `${onLeaveCounts[dataIndex]}`, // Show raw count on hover
//           },
//           {
//             data: lateArrivalProportionData,
//             label: "Late",
//             id: "lateId",
//             stack: "total",
//             color: SERIES_COLORS["Late-Arrival"],
//             valueFormatter: (value, { dataIndex }) =>
//               `${lateArrivalCounts[dataIndex]}`, // Show raw count on hover
//           },
//           {
//             data: weekOffProportionData,
//             label: "Weekly Off",
//             id: "weekOffId",
//             stack: "total",
//             color: SERIES_COLORS["Week Off"],
//             valueFormatter: (value, { dataIndex }) =>
//               `${weekOffCounts[dataIndex]}`,
//           },
//         ]}
//         barLabel={(item) => {
//           const { seriesId, dataIndex, value } = item;

//           console.log({ item }); // Debugging output

//           // Only show labels if value is greater than 0
//           if (value > 0) {
//             switch (seriesId) {
//               case "presentId":
//                 return `${presentCounts[dataIndex]}`;
//               case "absentId":
//                 return `${absentCounts[dataIndex]}`;
//               case "halfDayId":
//                 return `${halfDayCounts[dataIndex]}`;
//               case "leaveId":
//                 return `${onLeaveCounts[dataIndex]}`;
//               case "lateId":
//                 return `${lateArrivalCounts[dataIndex]}`;
//               case "weekOffId":
//                 return `${weekOffCounts[dataIndex]}`;
//               default:
//                 return "";
//             }
//           }

//           return "";
//         }}
//         tickPlacement="middle"
//         xAxis={[
//           {
//             data: storeNames,
//             scaleType: "band",
//             id: "x-axis-id",
//             tickLabelStyle: {
//               angle: 340,
//               textAnchor: "end",
//               fontSize: 9,
//               dominantBaseline: "hanging",
//               maxWidth: 100,
//               fill: "black",
//               cursor: "pointer",
//               pointerEvents: "auto",
//             },
//           },
//         ]}
//         yAxis={[
//           {
//             scaleType: "linear",
//             domain: [0, 1], // Fixed range from 0 to 1 (0% to 100%)
//             valueFormatter: (value) => `${(value * 100).toFixed(0)}%`,
//             axisLabel: "Percentage",
//           },
//         ]}
//         sx={{
//           "& .MuiChartsLegend-root": {
//             fontSize: "12px",
//             "& .MuiChartsLegend-mark": { width: "10px", height: "10px" },
//           },
//           "& .MuiBarElement-root": {
//             pointerEvents: "auto",
//             "& text": { fill: "#000", fontSize: "12px" },
//           },
//           "& .MuiChartsAxis-root.MuiChartsAxis-bottom": {
//             pointerEvents: "auto",
//             zIndex: 100,
//           },
//           "& .MuiChartsAxis-tickLabel": {
//             pointerEvents: "auto",
//             cursor: "pointer",
//             fill: "black",
//             zIndex: 101,
//           },
//         }}
//         slotProps={{
//           bar: {
//             style: { margin: "0 5px" },
//             label: {
//               position: "top",
//               style: { fill: "#000", fontSize: "12px" },
//             },
//           },
//           legend: {
//             itemMarkWidth: 10,
//             itemMarkHeight: 10,
//             labelStyle: { fontSize: "12px" },
//           },
//         }}
//         onItemClick={handleBarClick}
//       />

//       <Modal open={open} onClose={handleClose}>
//         <Box sx={modalStyle}>
//           <Typography
//             variant="h6"
//             component="h2"
//             gutterBottom
//             marginBottom={"25px"}
//           >
//             {selectedStore} - Attendance Overview ({selectedCategory?.name})
//           </Typography>

//           {selectedCategory?.data?.length > 0 ? (
//             <table id="example" className="table">
//               <thead>
//                 <tr>
//                   <th>Store Name</th>
//                   <th>Name</th>
//                   <th>Status</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {selectedCategory.data.map((item, index) => (
//                   <>
//                     {console.log(item.status)}
//                     <tr key={index}>
//                       <td>{selectedStore}</td>
//                       <td>{item.user_name}</td>
//                       <td>
//                         <span
//                           className={`status-btn status-${
//                             item.status === "Weekly Off"
//                               ? "Weekly-Off"
//                               : item.status?.replace(" ", "-")
//                           }`}
//                         >
//                           {item.status}
//                         </span>
//                       </td>
//                     </tr>
//                   </>
//                 ))}
//               </tbody>
//             </table>
//           ) : (
//             <Typography>No employees in this store</Typography>
//           )}
//         </Box>
//       </Modal>
//     </div>
//   );
// };

// export default Chart;

import React, { useState, useRef, useEffect } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import "./chart.css";

// Define series colors
const SERIES_COLORS = {
  Present: "#D4EDBC",
  Absent: "#FF0000",
  "Half-Day": "#C27BA0",
  "On-Leave": "#6FA8DC",
  "Late-Arrival": "#E69138",
  "Week Off": "#F1C232",
};

const Chart = ({
  getGraphListData,
  handleDate,
  handleClearSelection,
  datedash,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const chartRef = useRef(null);

  // Store names remain unchanged
  const storeNames = getGraphListData?.map((store) => store.store_name) || [];

  // Calculate total employees per store
  const storeTotals =
    getGraphListData?.map((store) => {
      return (
        store.Present.length +
        store.Absent.length +
        store["Half-Day"].length +
        store["On-Leave"].length +
        store["Late-Arrival"].length +
        store["Week Off"].length
      );
    }) || [];

  console.log("Store Totals:", storeTotals); // Debugging log

  // Calculate proportion data for each category
  const presentProportionData =
    getGraphListData?.map((store, index) => {
      return storeTotals[index] > 0
        ? store.Present.length / storeTotals[index]
        : 0;
    }) || [];
  const absentProportionData =
    getGraphListData?.map((store, index) => {
      return storeTotals[index] > 0
        ? store.Absent.length / storeTotals[index]
        : 0;
    }) || [];
  const halfDayProportionData =
    getGraphListData?.map((store, index) => {
      return storeTotals[index] > 0
        ? store["Half-Day"].length / storeTotals[index]
        : 0;
    }) || [];
  const onLeaveProportionData =
    getGraphListData?.map((store, index) => {
      return storeTotals[index] > 0
        ? store["On-Leave"].length / storeTotals[index]
        : 0;
    }) || [];
  const lateArrivalProportionData =
    getGraphListData?.map((store, index) => {
      return storeTotals[index] > 0
        ? store["Late-Arrival"].length / storeTotals[index]
        : 0;
    }) || [];
  const weekOffProportionData =
    getGraphListData?.map((store, index) => {
      return storeTotals[index] > 0
        ? store["Week Off"].length / storeTotals[index]
        : 0;
    }) || [];

  // Handle bar clicks (unchanged)
  const handleBarClick = (event, elements) => {
    console.log("Bar Click:", elements);
    if (elements?.seriesId && elements?.dataIndex !== undefined) {
      const { seriesId, dataIndex } = elements;
      const store = getGraphListData[dataIndex];
      let categoryData;
      let categoryName;
      let status;

      switch (seriesId) {
        case "presentId":
          categoryData = store.Present;
          categoryName = "Present";
          status = "Present";
          break;
        case "absentId":
          categoryData = store.Absent;
          categoryName = "Absent";
          status = "Absent";
          break;
        case "halfDayId":
          categoryData = store["Half-Day"];
          categoryName = "Half-Day";
          status = "Half-Day";
          break;
        case "leaveId":
          categoryData = store["On-Leave"];
          categoryName = "On-Leave";
          status = "On-Leave";
          break;
        case "lateId":
          categoryData = store["Late-Arrival"];
          categoryName = "Late-Arrival";
          status = "Late";
          break;
        case "weekOffId":
          categoryData = store["Week Off"];
          categoryName = "Week Off";
          status = "Weekly Off";
          break;
        default:
          return;
      }

      const updatedCategoryData = categoryData.map((item) => ({
        ...item,
        status,
      }));

      setSelectedCategory({ name: categoryName, data: updatedCategoryData });
      setSelectedStore(store.store_name);
      setOpen(true);
    }
  };

  // Attach click listeners to x-axis labels (unchanged)
  useEffect(() => {
    const chartElement = chartRef.current;
    if (!chartElement) {
      console.log("Chart ref not available yet");
      return;
    }

    console.log("Chart ref available:", chartElement);

    let labels = chartElement.querySelectorAll(".MuiChartsAxis-tickLabel");
    console.log("Initial labels check:", labels.length);

    const attachListeners = () => {
      labels = chartElement.querySelectorAll(".MuiChartsAxis-tickLabel");
      console.log("Attaching listeners. Found labels:", labels.length);

      if (labels.length === 0) {
        console.log(
          "No labels found yet. SVG content:",
          chartElement.innerHTML
        );
        return;
      }

      labels.forEach((label, index) => {
        label.style.pointerEvents = "auto";
        label.style.cursor = "pointer";

        const handleLabelClick = (event) => {
          event.stopPropagation();
          event.preventDefault();
          const storeName = label.textContent;
          const storeIndex = storeNames.indexOf(storeName);
          if (storeIndex !== -1) {
            const store = getGraphListData[storeIndex];
            const allStoreData = [
              ...store.Present.map((item) => ({ ...item, status: "Present" })),
              ...store.Absent.map((item) => ({ ...item, status: "Absent" })),
              ...store["Half-Day"].map((item) => ({
                ...item,
                status: "Half-Day",
              })),
              ...store["On-Leave"].map((item) => ({
                ...item,
                status: "On-Leave",
              })),
              ...store["Late-Arrival"].map((item) => ({
                ...item,
                status: "Late",
              })),
              ...store["Week Off"].map((item) => ({
                ...item,
                status: "Weekly Off",
              })),
            ];

            console.log(`Label ${index} Clicked:`, storeName);
            setSelectedCategory({ name: "All Categories", data: allStoreData });
            setSelectedStore(store.store_name);
            setOpen(true);
          } else {
            console.log("Store not found for label:", storeName);
          }
        };

        label.addEventListener("click", handleLabelClick);
      });
    };

    if (labels.length > 0) {
      attachListeners();
    } else {
      const observer = new MutationObserver((mutations) => {
        console.log("Mutation observed:", mutations);
        labels = chartElement.querySelectorAll(".MuiChartsAxis-tickLabel");
        if (labels.length > 0) {
          console.log("Labels detected after mutation:", labels.length);
          attachListeners();
          observer.disconnect();
        }
      });

      observer.observe(chartElement, { childList: true, subtree: true });
      console.log("MutationObserver started");

      const timeout = setTimeout(() => {
        labels = chartElement.querySelectorAll(".MuiChartsAxis-tickLabel");
        if (labels.length > 0) {
          console.log("Fallback: Labels found after timeout:", labels.length);
          attachListeners();
        } else {
          console.log(
            "Fallback: Still no labels after 2s:",
            chartElement.innerHTML
          );
        }
        observer.disconnect();
      }, 2000);

      return () => {
        observer.disconnect();
        clearTimeout(timeout);
        labels.forEach((label) => {
          label.removeEventListener("click", () => {});
        });
      };
    }

    return () => {
      labels.forEach((label) => {
        label.removeEventListener("click", () => {});
      });
    };
  }, [getGraphListData, chartRef.current]);

  const handleClose = () => {
    setOpen(false);
    setSelectedCategory(null);
    setSelectedStore(null);
  };

  const presentCounts =
    getGraphListData?.map((store) => store.Present.length) || [];
  const absentCounts =
    getGraphListData?.map((store) => store.Absent.length) || [];
  const halfDayCounts =
    getGraphListData?.map((store) => store["Half-Day"].length) || [];
  const onLeaveCounts =
    getGraphListData?.map((store) => store["On-Leave"].length) || [];
  const lateArrivalCounts =
    getGraphListData?.map((store) => store["Late-Arrival"].length) || [];
  const weekOffCounts =
    getGraphListData?.map((store) => store["Week Off"].length) || [];

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1100,
    bgcolor: "background.paper",
    border: "1px solid #000",
    boxShadow: 24,
    p: 4,
  };

  return (
    <div
      style={{
        padding: "10px 0px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "20px",
      }}
    >
      <div className="d-flex justify-content-between w-100">
        <h2
          className="text-center"
          style={{ width: "-webkit-fill-available", marginLeft: "120px" }}
        >
          Attendance Summary
        </h2>
        <div className="calendar_pad w-[25]">
          <div className="calendar">
            <input type="date" value={datedash} onChange={handleDate} />
            {datedash && (
              <div className="calenderClear">
                <svg
                  width="20"
                  height="25"
                  viewBox="0 0 60 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={handleClearSelection}
                >
                  <rect
                    width="60"
                    height="60"
                    rx="30"
                    fill="#2C357D"
                    fill-opacity="0.15"
                  />
                  <path
                    d="M37.75 22.1377L21.25 38.6377"
                    stroke="#2C357D"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21.25 22.1377L37.75 38.6377"
                    stroke="#2C357D"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            )}
          </div>
        </div>
      </div>

      <BarChart
        ref={chartRef}
        height={500}
        margin={{ top: 40, bottom: 100, left: 50, right: 20 }} // Adjusted margins
        series={[
          {
            data: presentProportionData,
            label: "Present",
            id: "presentId",
            stack: "total",
            color: SERIES_COLORS["Present"],
            valueFormatter: (value, { dataIndex }) =>
              `${presentCounts[dataIndex]}`, // Show raw count on hover
          },
          {
            data: absentProportionData,
            label: "Absent",
            id: "absentId",
            stack: "total",
            color: SERIES_COLORS["Absent"],
            valueFormatter: (value, { dataIndex }) =>
              `${absentCounts[dataIndex]}`, // Show raw count on hover
          },
          {
            data: halfDayProportionData,
            label: "Half-Day",
            id: "halfDayId",
            stack: "total",
            color: SERIES_COLORS["Half-Day"],
            valueFormatter: (value, { dataIndex }) =>
              `${halfDayCounts[dataIndex]}`, // Show raw count on hover
          },
          {
            data: onLeaveProportionData,
            label: "On-Leave",
            id: "leaveId",
            stack: "total",
            color: SERIES_COLORS["On-Leave"],
            valueFormatter: (value, { dataIndex }) =>
              `${onLeaveCounts[dataIndex]}`, // Show raw count on hover
          },
          {
            data: lateArrivalProportionData,
            label: "Late",
            id: "lateId",
            stack: "total",
            color: SERIES_COLORS["Late-Arrival"],
            valueFormatter: (value, { dataIndex }) =>
              `${lateArrivalCounts[dataIndex]}`, // Show raw count on hover
          },
          {
            data: weekOffProportionData,
            label: "Weekly Off",
            id: "weekOffId",
            stack: "total",
            color: SERIES_COLORS["Week Off"],
            valueFormatter: (value, { dataIndex }) =>
              `${weekOffCounts[dataIndex]}`,
          },
          {
            data: Array(storeTotals.length).fill(0.1),
            label: "",
            id: "totalId",
            stack: "total",
            color: "rgba(0, 0, 0, 0)",
            valueFormatter: () => "",
          },
        ]}
        barLabel={(item) => {
          const { seriesId, dataIndex, value } = item;

          // Calculate the total number of users for each store
          const totalUsers =
            presentCounts[dataIndex] +
            absentCounts[dataIndex] +
            halfDayCounts[dataIndex] +
            onLeaveCounts[dataIndex] +
            lateArrivalCounts[dataIndex] +
            weekOffCounts[dataIndex];

          // Only show labels if value is greater than 0

          if (seriesId === "totalId") {
            return totalUsers > 0 ? `${totalUsers}` : "";
          }
          if (value > 0) {
            switch (seriesId) {
              case "presentId":
                return `${presentCounts[dataIndex]}`;
              case "absentId":
                return `${absentCounts[dataIndex]}`;
              case "halfDayId":
                return `${halfDayCounts[dataIndex]}`;
              case "leaveId":
                return `${onLeaveCounts[dataIndex]}`;
              case "lateId":
                return `${lateArrivalCounts[dataIndex]}`;
              case "weekOffId":
                return `${weekOffCounts[dataIndex]}`;
              default:
                return "";
            }
          }

          return "";
        }}
        tickPlacement="middle"
        xAxis={[
          {
            data: storeNames,
            scaleType: "band",
            id: "x-axis-id",
            tickLabelStyle: {
              angle: 270,
              textAnchor: "end",
              fontSize: 9,
              dominantBaseline: "hanging",
              maxWidth: 100,
              fill: "black",
              cursor: "pointer",
              pointerEvents: "auto",
            },
          },
        ]}
        yAxis={[
          {
            scaleType: "linear",
            domain: [0, 1], // Fixed range from 0 to 1 (0% to 100%)
            valueFormatter: () => "",
            axisLabel: "Percentage",
            tickLabelStyle: {
              display: "none", // Explicitly hide tick labels
            },
          },
        ]}
        sx={{
          "& .MuiChartsLegend-root": {
            fontSize: "12px",
            "& .MuiChartsLegend-mark": { width: "10px", height: "10px" },
          },
          "& .MuiBarElement-root": {
            pointerEvents: "auto",
            "& text": { fill: "#000", fontSize: "12px" },
          },
          "& .MuiChartsAxis-root.MuiChartsAxis-bottom": {
            pointerEvents: "auto",
            zIndex: 100,
          },
          "& .MuiChartsAxis-tickLabel": {
            pointerEvents: "auto",
            cursor: "pointer",
            fill: "black",
            zIndex: 101,
          },
          "& .MuiChartsAxis-root": {
            "& text": {
              display: "block !important",
              visibility: "visible !important",
              opacity: 1,
            },
          },
        }}
        slotProps={{
          bar: {
            style: { margin: "0 5px" },
            label: {
              position: "top",
              style: { fill: "#000", fontSize: "12px" },
            },
          },
          legend: {
            itemMarkWidth: 10,
            itemMarkHeight: 10,
            labelStyle: { fontSize: "12px" },
          },
        }}
        onItemClick={handleBarClick}
      />
      <Modal open={open} onClose={handleClose}>
        <Box sx={modalStyle}>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            marginBottom={"25px"}
          >
            {selectedStore} - Attendance Overview ({selectedCategory?.name})
          </Typography>

          {selectedCategory?.data?.length > 0 ? (
            <table id="example" className="table">
              <thead>
                <tr>
                  <th>Store Name</th>
                  <th>Name</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {selectedCategory.data.map((item, index) => (
                  <>
                    {console.log(item.status)}
                    <tr key={index}>
                      <td>{selectedStore}</td>
                      <td>{item.user_name}</td>
                      <td>
                        <span
                          className={`status-btn status-${
                            item.status === "Weekly Off"
                              ? "Weekly-Off"
                              : item.status?.replace(" ", "-")
                          }`}
                        >
                          {item.status}
                        </span>
                      </td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          ) : (
            <Typography>No employees in this store</Typography>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default Chart;
